import React, { Component } from "react";
import { Link } from "react-router-dom";
import cookies from "js-cookie";
import jwtDecode from "jwt-decode";
import { withRouter } from "react-router-dom";
import { Alert } from "reactstrap";

import classes from "./SideBar.module.scss";


class SideBar extends Component {
  state = {
    selected: -1,
    pages: [],
  };

 updateLinks(selected){
  let links = [];
  links.push({
    display: "Campaign Map",
    path: `/dashboard/admin/advertise/client/impersonate/${this.props.client.id}/campaign/${selected}/map`
  });
  links.push({
    display: "Analytics",
    path: `/dashboard/admin/advertise/client/impersonate/${this.props.client.id}/campaign/${selected}/analytics`
  });
  this.setState({
    pages: links
  });
}

  componentDidMount() {
    this.updateLinks(this.props.selected);

    let path = window.location.pathname;
    if (path.endsWith("map")){
      this.setState({ selected: 0 });
    }
    else if (path.endsWith("analytics")) {
      this.setState({ selected: 0 });
    }

  }

  async componentDidUpdate(prevProps, prevState) {
    if(this.props.selected && this.props.selected != prevProps.selected){
      this.updateLinks(this.props.selected);
    }
}

  onLinkClickhandler(id) {
    this.setState({
      selected: id
    });
  }

  render() {
    let selectedClass = [classes.button, classes.selected].join(" ");
    let links = this.state.pages.map((page, index) => (
      <Link
        key={index}
        to={page.path}
        onClick={() => this.onLinkClickhandler(index)}
        className={this.state.selected === index ? selectedClass : classes.button}
      >
        {page.display}
      </Link>
    ));

    return (
      <div className={classes.sideBar}>
      <Alert color="info">
      <h5>Client Dashboard Preview</h5>
      You are viewing <b>{this.props.client.name}'s</b> dashboard</Alert>
        {links}

      </div>
    );
  }
}

export default SideBar;
